import { createRouter, createWebHistory } from 'vue-router'

// 定义路由配置
const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('../views/Index.vue'),
    meta: {
      title: '首页 - 合肥联静数字科技有限公司',
      keepAlive: true
    }
  },
  {
    path: '/lr',
    name: 'lr',
    component: () => import('../views/Lr.vue'),
    meta: {
      title: 'LR - 专业视频剪辑工具',
      keepAlive: true
    }
  },
  {
    path: '/motion',
    name: 'motion',
    component: () => import('../views/Motion.vue'),
    meta: {
      title: 'Motion - 视频创作神器',
      keepAlive: true
    }
  },
  {
    path: '/kuaijian',
    name: 'kuaijian',
    component: () => import('../views/Kuaijian.vue'),
    meta: {
      title: '快剪 - 让视频剪辑变得简单而精彩的AI神器',
      keepAlive: true
    }
  },
  {
    path: '/yinghua',
    name: 'yinghua',
    component: () => import('../views/Yinghua.vue'),
    meta: {
      title: '樱花校园 - 趣味校园生活模拟游戏',
      keepAlive: true
    }
  },
  {
    path: '/yingtao',
    name: 'yingtao',
    component: () => import('../views/Yingtao.vue'),
    meta: {
      title: '樱桃视频 - 发现美好，分享精彩',
      keepAlive: true
    }
  },
  {
    path: '/kuaiying',
    name: 'kuaiying',
    component: () => import('../views/Kuaiying.vue'),
    meta: {
      title: '快赢 - 快速制作专业级视频',
      keepAlive: true
    }
  },
  {
    path: '/xiangjiao',
    name: 'xiangjiao',
    component: () => import('../views/Xiangjiao.vue'),
    meta: {
      title: '香蕉视频剪辑秀 - 创意视频编辑工具',
      keepAlive: true
    }
  },
  {
    path: '/hsjt',
    name: 'hsjt',
    component: () => import('../views/Hsjt.vue'),
    meta: {
      title: '微商截图王 - 微商人的必备神器',
      keepAlive: true
    }
  },
  {
    path: '/faceapp',
    name: 'faceapp',
    component: () => import('../views/Faceapp.vue'),
    meta: {
      title: 'FaceApp - 打造专业级视频作品',
      keepAlive: true
    }
  },
  {
    path: '/facetune',
    name: 'facetune',
    component: () => import('../views/Facetune.vue'),
    meta: {
      title: 'Facetune - 开启指尖上的视频魔法之旅',
      keepAlive: true
    }
  },
  {
    path: '/meiying',
    name: 'meiying',
    component: () => import('../views/Meiying.vue'),
    meta: {
      title: '魅影 - 一站式视频创作神器',
      keepAlive: true
    }
  },
  {
    path: '/siguavideo',
    name: 'siguavideo',
    component: () => import('../views/SiguaVideo.vue'),
    meta: {
      title: '丝瓜视频剪辑 - 高效易用的视频剪辑工具',
      keepAlive: true
    }
  },
  {
    path: '/jiakaomingxiao',
    name: 'jiakaomingxiao',
    component: () => import('../views/JiaKaoMingXiao.vue'),
    meta: {
      title: '科目一驾考名校 - 一站式驾考辅助工具',
      keepAlive: true
    }
  },
  // 404 页面
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('../views/NotFound.vue'),
    meta: {
      title: '页面未找到'
    }
  }
]

// 创建路由实例
const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的位置（前进/后退），恢复到该位置
    if (savedPosition) {
      return savedPosition
    } else {
      // 否则返回顶部
      return { top: 0 }
    }
  }
})

// 路由守卫：更新页面标题
router.beforeEach((to, from, next) => {
  // 更新页面标题
  if (to.meta.title) {
    document.title = to.meta.title
  }
  
  // 添加页面加载状态
  document.body.classList.add('page-loading')
  
  next()
})

// 路由后守卫：页面加载完成后移除加载状态
router.afterEach(() => {
  setTimeout(() => {
    document.body.classList.remove('page-loading')
  }, 100)
})

export default router
